<style lang="less">
.app-side-bar {
  width: 256px;
  z-index: 999;
  .logo {
    height: 64px;
    background: #002140;
    overflow: hidden;
    margin-bottom: 20px;
    a {
      padding-left: 20px;
      height: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      img {
        width: 32px;
        height: 32px;
      }
      h1 {
        min-width: 120px;
        font-size: 14px;
        margin: 5px 0 0 6px;
        font-weight: 600;
        color: #fff;
      }
    }
  }
  .el-menu-item,
  .el-submenu .el-menu-item,
  .el-submenu .el-submenu__title {
    line-height: 40px;
    height: 40px;
    margin-bottom: 8px;
    background-color: #001529!important;
    span,
    svg {
      transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
        background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    }
  }
  .el-submenu .el-menu-item__title {
    span,
    i {
      color: rgba(255, 255, 255, 0.65);
      font-weight: normal;
    }
    span {
      font-size: 14px;
    }
  }
  .el-menu-item.is-active {
    position: relative;
    background-color: #1890ff!important;
    span,
    svg {
      color: #fff;
    }
  }
  .el-menu-item.is-opened,
  .el-menu--inline {
    background-color: #001529;
  }
}
.app-side-bar.el-menu--collapse {
  width: 80px;
  span,
  i,
  h1 {
    display: none;
  }
  svg {
    margin-left: 10px;
  }
  .el-menu-item.is-active {
    background-color: #001529!important;
    &:after {
      display: none;
    }
    svg {
      color: #1890ff;
    }
  }
}
</style>

<template>
  <el-menu class="app-side-bar" :show-timeout="200" :default-active="$route.name" :collapse="isCollapse" mode="vertical" text-color="#acb3b8" active-text-color="#fff">
    <div class="logo">
      <router-link to="/">
        <img src="@/assets/logo.png" />
        <h1>{{title}}</h1>
      </router-link>
    </div>

    <sidebar-item v-for="route in routes" :key="route.name" :item="route" />
  </el-menu>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import SidebarItem from './SidebarItem'

const { mapState, mapGetters } = createNamespacedHelpers('app')

export default {
  components: { SidebarItem },
  computed: {
    ...mapState(['sidebar']),
    ...mapGetters(['routes']),
    title() {
      return this.$config.title
    },

    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>
